import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import useLessonAssignment from 'state/providers/LessonAssignmentProvider';
import { faFileAudio } from '@fortawesome/free-solid-svg-icons';
import { TrashButton } from 'components/TrashButton';

export const FilesContent = ({ handleRemove }) => {
  const [{ lessonAssignmentState, stepOneFormState }] = useLessonAssignment();
  const classes = useStyles();

  return (
    <Box display="flex">
      {stepOneFormState.form?.[lessonAssignmentState.activeFormId].audioFiles.length > 0 && (
        <>
          {stepOneFormState.form?.[lessonAssignmentState.activeFormId].audioFiles?.map((x: any) => (
            <Box className={classes.container} key={x?.title || x?.name}>
              <Box className={classes.title}>
                <FontAwesomeIcon icon={faFileAudio} size="sm" style={{ margin: '0 5px' }} />
                <Typography>{x?.title || x?.name}</Typography>
              </Box>
              <TrashButton handleRemove={handleRemove(x.name)} />
            </Box>
          ))}
        </>
      )}
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  title: {
    display: 'flex',
    alignItems: 'center'
  }
}));
